import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  Button,
  Alert,
  Snackbar,
  Box,
  Typography,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";
import InfoIcon from "@mui/icons-material/Info";
import "./../../../styles/invoice.css"; // External CSS for styling
import RefreshIcon from "@mui/icons-material/Refresh";
import "rsuite/dist/rsuite.min.css";
import { DateRangePicker } from "rsuite";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { FormatNumber, FormatNumberRedeem } from "../../../utils/formatNumber";
import Loading from "../../Dashboard/Loading";
import Datefilter from "../../../utils/Datefilter";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReplayIcon from "@mui/icons-material/Replay";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import moment from "moment";
import { fontSize } from "@mui/joy/styles/styleFunctionSx";

interface Timeline {
  orderCreated?: {
    title: string;
    timestamp?: number;
    status: string;
  };
  paymentReceived?: {
    title: string;
    timestamp?: number;
    status: string;
  };
  orderProcessed?: {
    title: string;
    timestamp?: number;
    status: string;
  };
  orderSettled?: {
    title: string;
    timestamp?: number;
    status: string;
  };
}

export default function DateWisePreIpoTransactions({ accessToken }: any) {
  const [tranx, setTranx] = useState<any>([]);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [isOpenBank, setIsOpenBank] = useState<boolean>(false);
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  let timelineData: any = [];

  const [columns, setColumns] = useState([
    {
      field: "id",
      headerName: "S.No",
      width: 90,
      renderHeader: () => <strong>{"S.No"}</strong>,
    },
    {
      field: "trade_date",
      headerName: "Trade Date",
      width: 240,
      renderHeader: () => <strong>{"Trade Date"}</strong>,
      renderCell: (params) => {
        let { items } = params.row;
        return (
          <div
            style={{
              minHeight: "50px",
              display: "flex",
              alignItems: "center", // Center vertically
              justifyContent: "center", // Center horizontally
              width: "100%",
              textAlign: "start", // Center text inside the div
            }}
          >
            {moment(items[0].trade_date).format("DD/MM/YYYY")}
          </div>
        );
      },
    },
    {
      field: "settlementDate",
      headerName: "Expected Settlement Date",
      width: 240,
      renderHeader: () => <strong>{"Expected Settlement Date"}</strong>,
      renderCell: (params) => {
        let { items, payment } = params.row;

        let date = "";

        if (payment.status === "FAILED") {
          date = "-";
        } else {
          date = moment(items[0].metadata.price.settlementDate).format(
            "DD/MM/YYYY"
          );
        }

        return (
          <div
            style={{
              minHeight: "50px",
              display: "flex",
              alignItems: "center", // Center vertically
              justifyContent: "center", // Center horizontally
              width: "100%",
              textAlign: "start", // Center text inside the div
            }}
          >
            {date}
          </div>
        );
      },
    },
    {
      field: "Name",
      headerName: "Name",
      width: 380,
      renderHeader: () => <strong>{"Name"}</strong>,
      renderCell: (params) => {
        let { items } = params.row;
        return (
          <div
            style={{
              minHeight: "50px",
              display: "flex",
              alignItems: "center", // Center vertically
              justifyContent: "center", // Center horizontally
              width: "100%",
              textAlign: "center", // Center text inside the div
            }}
          >
            {items[0].name}
          </div>
        );
      },
    },
    {
      field: "UNITS",
      headerName: "Amount",
      width: 100,
      renderHeader: () => <strong>{"Units"}</strong>,
      renderCell: (params) => {
        const { items } = params.row;

        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">
              {FormatNumber(items[0].units)}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "Price Per Unit",
      headerName: "Price Per Unit",
      width: 180,
      renderHeader: () => <strong>{"Price Per Unit"}</strong>,
      renderCell: (params) => {
        const { items } = params.row;

        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">
              {FormatNumber(items[0].unit_price)}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "Total Amount",
      headerName: "Total Amount",
      width: 180,
      renderHeader: () => <strong>{"Total Amount"}</strong>,
      renderCell: (params) => {
        const { amount } = params.row;

        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">{FormatNumber(amount)}</Typography>
          </Box>
        );
      },
    },
    {
      field: "Order Status",
      headerName: "Order Status",
      width: 150,
      renderHeader: () => <strong>{"Order Status"}</strong>,
      renderCell: (params) => {
        const { status, _id } = params.row;

        const getStatusColor = (status: string) => {
          switch (status) {
            case "failed":
              return "error";
            case "success":
              return "success";
            case "inProgress":
              return "primary";
            case "pending":
              return "grey";
            default:
              return "grey";
          }
        };

        return (
          <div
            style={{
              minHeight: "50px",
              alignItems: "center",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              // padding: "0 10px",
              gap: "5px",
            }}
          >
            <span>{status}</span>
            <Tooltip
              onOpen={() => fetchTimeline(_id)}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "black",
                    "& .MuiTooltip-arrow": {
                      color: "white",
                    },
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                  },
                },
              }}
              arrow
              placement="right"
              title={
                 timelineMsg && timelineMsg !== "" ? (
                  <Box sx={{ p: 2, maxWidth: 300, bgcolor: "#fff8f8", borderRadius: "4px" }}>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: "#d32f2f" }}>
                      {timelineMsg}
                    </Typography>
                  </Box>
                ) : 
                loadingTimeline ? (
                  <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  <Timeline
                    sx={{
                      padding: "16px 8px",
                      margin: 0,
                      "& .MuiTimelineContent-root": { flex: 12 },
                      minWidth: "300px",
                      position: "relative",
                      left: "-8px",
                    }}
                  >
                    {timelineData.map((item, index) => (
                      <TimelineItem
                        key={index}
                        sx={{
                          minHeight: "auto",
                          "&:before": { display: "none" },
                          "& .MuiTimelineContent-root": {
                            padding: "0 16px 20px",
                          },
                          "& .MuiTimelineSeparator-root": {
                            marginLeft: "7px",
                          },
                        }}
                      >
                        <TimelineSeparator>
                          <TimelineDot
                            color={getStatusColor(item.status) as any}
                            sx={{
                              margin: 0,
                              marginTop: "12px",
                              boxShadow: "0 0 0 3px rgba(255,255,255,0.8)",
                            }}
                          />
                          {index < timelineData.length - 1 && (
                            <TimelineConnector
                              sx={{
                                backgroundColor: "#e0e0e0",
                                width: "2px",
                                minHeight: "30px",
                              }}
                            />
                          )}
                        </TimelineSeparator>
                        <TimelineContent>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              bgcolor: "rgba(0,0,0,0.02)",
                              borderRadius: "8px",
                              p: 1.5,
                              "&:hover": {
                                bgcolor: "rgba(0,0,0,0.04)",
                              },
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ color: "#333", fontWeight: 500 }}
                            >
                              {item.title}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              {item.timestamp && (
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#666" }}
                                >
                                  {moment(item.timestamp).format(
                                    "DD/MM/YYYY hh:mm A"
                                  )}
                                </Typography>
                              )}
                              <Typography
                                variant="caption"
                                sx={{
                                  color:
                                    item.status === "success"
                                      ? "#2e7d32"
                                      : item.status === "inProgress"
                                      ? "#1976d2"
                                      : item.status === "failed"
                                      ? "red"
                                      : "#666",
                                  fontWeight: 600,
                                  bgcolor:
                                    item.status === "success"
                                      ? "rgba(46,125,50,0.1)"
                                      : item.status === "inProgress"
                                      ? "rgba(25,118,210,0.1)"
                                      : item.status === "failed"
                                      ? "rgba(210, 25, 25, 0.1)"
                                      : "rgba(0,0,0,0.1)",
                                  px: 1,
                                  py: 0.25,
                                  borderRadius: "4px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {item.status}
                              </Typography>
                            </Box>
                          </Box>
                        </TimelineContent>
                      </TimelineItem>
                    ))}
                  </Timeline>
                )
              }
            >
              <InfoIcon
                sx={{
                  fontSize: 18,
                  ml: 1,
                  color: "#666",
                  cursor: "pointer",
                  transition: "color 0.2s",
                  "&:hover": {
                    color: "#1976d2",
                  },
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "Payment Status",
      headerName: "Payment Status",
      width: 240,
      renderHeader: () => <strong>{"Payment Status"}</strong>,
      renderCell: (params) => {
        let { _id, payment } = params.row;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <div
              style={{
                minHeight: "50px",
                alignItems: "center",
                display: "flex",
                width: "100%",
                justifyContent: "center", // Center horizontally
              }}
            >
              {payment.status ?? "PENDING"}
            </div>
            {/* <div
              style={{ paddingTop: "3px", color: "#318AD6", cursor: "pointer" }}
              onClick={() => orderRefresh(_id)}
            >
              <Tooltip title="Refresh">
                <RefreshIcon sx={{ fontSize: "18px" }} />
              </Tooltip>
            </div> */}
          </div>
        );
      },
    },
  ]);

  const [loading, setLoading] = useState(false);

  //   const dateConverter = (str) => {
  //     const month = [
  //       "Jan",
  //       "Feb",
  //       "Mar",
  //       "Apr",
  //       "May",
  //       "Jun",
  //       "Jul",
  //       "Aug",
  //       "Sep",
  //       "Oct",
  //       "Nov",
  //       "Dec",
  //     ];
  //     var date = new Date(str);
  //     var mnth = date.getMonth();
  //     var day = ("0" + date.getDate()).slice(-2);
  //     var year = date.getFullYear();
  //     return `${day}-${month[mnth]}-${year}`;
  //   };

  //   const [IntervalDate, setIntervalDate] = useState({
  //     startDate: dateConverter(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
  //     endDate: dateConverter(new Date().getTime()),
  //   });

  //   const [Interval, setInterval] = useState({
  //     startDate: dateConverter(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
  //     endDate: dateConverter(new Date().getTime()),
  //   });

  const getTranxData = async () => {
    setLoading(true);
    // const startDate = new Date(IntervalDate.startDate).getTime();
    // const endDate = new Date(IntervalDate.endDate).getTime();
    // const diff = endDate - startDate;
    // const ThirtyDays = 1000 * 60 * 60 * 24 * 30;
    // if (diff > ThirtyDays) {
    //   setLoading(false);
    //   setMessage("Difference between the dates cannot be more than 30 days");
    //   setError(true);
    //   return;
    // }

    // Adjust the end date to the end of the selected day
    // const endOfDay = new Date(IntervalDate.endDate);
    // endOfDay.setHours(23, 59, 59, 999);

    axios
      .get(`${process.env.REACT_APP_BACKEND_HOST}v1/preIpo/orders`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        const { data } = res;
        setLoading(false);

        if (!data.succ) {
          setError(true);
          setMessage(data.message);
          setTranx([]);
          return;
        }

        setTranx(data.data.collection);
      })
      .catch((error) => {
        console.log("error from get pre ipo transaction api ->", error);

        setLoading(false);
        setError(true);
        setTranx([]);
        setMessage("Failed to Fetching Data from Server");
        return;
      });
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      // setIsLoading(true);
      getTranxData();
    }, 2000);
  }, []);

  //   const changeHandler = (name, value) => {
  //     setIntervalDate((prev) => ({
  //       ...prev,
  //       [name]: dateConverter(value),
  //     }));
  //   };

  const orderRefresh = (order_id: string) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_HOST}v1/preIpo/order/refresh?id=${order_id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        const { data } = res;

        if (!data.succ) {
          setError(true);
          setMessage(data.message);
          return;
        }

        setSuccess(true);
        setMessage(data.data.message);

        getTranxData();
      })
      .catch((error) => {
        console.log("error from get pre ipo transaction api ->", error);

        setLoading(false);
        setError(true);
        setTranx([]);
        setMessage("Failed to Fetching Data from Server");
        return;
      });
  };

  const [timelineMsg, setTimelineMsg] = useState("");

  const fetchTimeline = async (id) => {
    try {
      // Clear previous message
      setTimelineMsg("");
      setLoadingTimeline(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}v1/preIpo/order/timeline?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data.succ) {
        timelineData = Object.entries(response.data.data).map(
          ([key, value]: any) => ({
            title: value?.title,
            timestamp: value?.timestamp,
            status: value?.status,
          })
        );
      } else {
        setTimelineMsg(response.data.message);
        timelineData = [];
      }
    } catch (error) {
      console.error("Error fetching timeline:", error);
    } finally {
      setLoadingTimeline(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Grid container spacing={2} xs>
          <Grid item xs={12} sx={{ ml: { xs: 0, md: 4 }, height: "77vh" }}>
            <Snackbar
              open={isError}
              autoHideDuration={6000}
              onClose={() => setError(false)}
            >
              <Alert severity="error">{message}</Alert>
            </Snackbar>
            <Snackbar
              open={isSuccess}
              autoHideDuration={6000}
              onClose={() => setSuccess(false)}
            >
              <Alert severity="success">{message}</Alert>
            </Snackbar>
            <AppBar
              sx={{
                backgroundColor: "white",
                marginLeft: { xs: "5%", md: 0 },
                display: "flex",
                width: { xs: "96vw", md: "81.5vw" },
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
              position="static"
              elevation={0}
            >
              {/* <Toolbar
                sx={{
                  display: "flex",
                  alignItems: "center",
                  margin: "0px",
                  padding: 0,
                }}
              >
                <Datefilter
                  name="startDate"
                  label="From Date"
                  value={IntervalDate.startDate}
                  changeHandler={changeHandler}
                  maxDate={Interval.endDate}
                  minDate={Interval.startDate}
                  inputFormat="dd-MMM-yyyy"
                />
                <Datefilter
                  name="endDate"
                  label="To Date"
                  value={IntervalDate.endDate}
                  changeHandler={changeHandler}
                  maxDate={Interval.endDate}
                  minDate={Interval.startDate}
                  inputFormat="dd-MMM-yyyy"
                />
                <Button
                  sx={{ marginTop: "-3px", height: "37px" }}
                  variant="contained"
                  color="primary"
                  onClick={getTranxData}
                >
                  Search
                </Button>
              </Toolbar> */}
            </AppBar>
            <Box
              sx={{
                height: "100%",
                // display: { xs: "none", sm: "block" },
                width: { xs: "96.5vw", md: "80vw" },
                ml: { xs: 3, sm: 0 },
              }}
            >
              <DataGrid
                sx={{ mt: 1 }}
                getRowHeight={() => "auto"}
                //  hideFooter={true}
                rowsPerPageOptions={[50, 100, 1000]}
                // rows={rows}
                rows={tranx?.map((each: any, idx: number) => {
                  return { ...each, id: idx + 1 };
                })}
                columns={columns.map((each, idx) => {
                  return {
                    id: idx + 1,
                    ...each,
                    headerAlign: "center",
                    align: "center",
                    sx: {
                      size: 2,
                    },
                  };
                })}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
}
